module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/studio-suns_spot_02-ab5e141105ee9d58d0fd0b70fbf0f41f.jpg";